// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".article__video-banner .primisslate{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;max-width:433px;margin:0 auto}@media (max-width:767px){.article__video-banner .primisslate{max-width:100%}}.global-wrapper.preview-mode .article__video-banner.video-banner__wrapper{height:244px}", ""]);
// Exports
module.exports = exports;
